module.exports = __webpack_public_path__ + "static/media/profile_pic.ae86a50d.jpg";